import Glide from '@glidejs/glide'

new Glide('.glide', {
    autoplay: 5000,
    hoverpause: true,
    animationDuration: 1500,
    direction: 'ltr'
}).mount()
